declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const initGA = (measurementId: string): void => {
  if (!measurementId || typeof window === "undefined") return;

  // Only load script once
  if (!window.gtag) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });
};

export const trackPageView = (measurementId: string, path: string): void => {
  if (!measurementId || !window.gtag) return;
  window.gtag("config", measurementId, { page_path: path });
};

export const logEvent = (
  eventName: string,
  params?: Record<string, unknown>
): void => {
  if (!window.gtag) return;
  window.gtag("event", eventName, params || {});
};
